/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleCircleIcon16Light = forwardRef('MoneyCurrencyRubleCircleIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 9h1.5a2.5 2.5 0 0 0 0-5H6.69a.69.69 0 0 0-.69.69V8h-.5a.5.5 0 0 0 0 1H6v1h-.5a.5.5 0 0 0 0 1H6v.75a.5.5 0 0 0 1 0V11h2.25a.5.5 0 0 0 0-1H7V9Zm0-4v3h1.5a1.5 1.5 0 1 0 0-3H7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.004a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z" })));
});
